import {Theme} from '@mui/material'

import {customThemeConstants} from '../../theme'

export const TABLE_Z_INDEX = {
  cell: 1,
  pinnedBodyCell: 200,
  pinnedHeaderCell: 300
} as const

export const selectableTableRowSx = (selected?: boolean) => ({
  cursor: 'pointer',
  backgroundColor: selected ? customThemeConstants().palette.contentSelected : 'none',
  '&:hover': {
    backgroundColor: selected
      ? customThemeConstants().palette.contentSelectedHover
      : customThemeConstants().palette.contentHover
  }
})

// The overlap shadow is a faint black on light surfaces; on dark surfaces it needs
// a stronger black to remain visible as a pinned-column separator.
const getTableColumnOverlapShadow = (theme: Theme): string =>
  theme.palette.mode === 'dark'
    ? 'rgba(0, 0, 0, 0.5)'
    : customThemeConstants().palette.tableColumnOverlapShadow

const commonShadowStyles = (theme: Theme) => ({
  content: '""',
  height: '100%',
  position: 'absolute',
  top: 0,
  width: '10px',
  boxShadow: `${getTableColumnOverlapShadow(theme)} 10px 0px 6px -6px inset`
})

export const pinnedColumnShadowStyles = (theme: Theme) => ({
  ...commonShadowStyles(theme),
  right: '-10px'
})

export const pinnedColumnShadowStylesLeft = (theme: Theme) => ({
  ...commonShadowStyles(theme),
  boxShadow: `${getTableColumnOverlapShadow(theme)} -10px 0px 6px -6px inset`,
  left: '-10px'
})
